// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c539c454","488":"7e1d6039","977":"cb4d9c89"}[chunkId] + ".chunk.js";
};